export default "__VITE_ASSET__U6Sephy1__"